import { API_CONFIG } from 'config/api'
import { SupportedChainId } from 'config/chains'
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// BERA MIGRATION: this is where our 'official' token list currently lives,
//                 update for more default tokens on platform
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export const KODIAK_LIST_MAINNET = `https://static.kodiak.finance/tokenLists/berachain_mainnet.json?v=${__BUILD_TIME__}`
export const KODIAK_LP_LIST_MAINNNET = 'https://static.kodiak.finance/dist/tokenLists/production/kodiak-lp-list.json'
export const KODIAK_LIST_BEPOLIA = 'https://static.kodiak.finance/tokenLists/berachain_bepolia.json'
export const KODIAK_LIST_ROBINHOOD = `${API_CONFIG.baseUrl}/token-list?chainId=4663&v=${__BUILD_TIME__}`

// this is the default list of lists that are exposed to users
// lower index == higher priority for token import
const DEFAULT_LIST_OF_LISTS_TO_DISPLAY: string[] = [
  KODIAK_LIST_MAINNET,
  KODIAK_LP_LIST_MAINNNET,
  KODIAK_LIST_BEPOLIA,
  KODIAK_LIST_ROBINHOOD,
]

export const DEFAULT_LIST_OF_LISTS: string[] = [...DEFAULT_LIST_OF_LISTS_TO_DISPLAY]

const ISLANDS_TO_FARM_DATA: { [chainId: string]: Record<string, string | undefined> } = {
  [SupportedChainId.BERA]: {
    '0x4a254B11810B8EBb63C5468E438FC561Cb1bB1da': '0x40C4d0a87157c3C1Df26267AC02505D930BAeEEb', // WBERA-HONEY
    '0x9659dc8c1565E0bd82627267e3b4eEd1a377ebE6': '0xF41eCc551E3c7449E74a7a7464BB2674fA76954c', // WBERA-WETH
    '0xEc8BA456b4e009408d0776cdE8B91f8717D13Fa1': '0x1C8e199c6c42D5ccE652Cf02002694D937118177', // WBERA-YEET
    '0xF06EA29FCF4765200742d29E685973a1870EaC98': '0x0d74359866a86d0f192f5cd53d103d299043165b', // wbtc-wbera
    '0x0FD67ac75F9DF51f5d81F582417B318F44b45f5c': '0x138b9fcc820bb56fa9accc99fd2041f7d1363ec1', // bm-wbera
    '0x93A913351CaE2D8C82C4b85f699726947eB76d32': '0x6F22221dC5845A25597BC96629D92F2b4979D943', // wbera-ramen
    '0x09A2070e4c0379288ba2FcaFf304b5BE2A9616d8': '0xc6d2205aabbdc0d7ce40a05eb6a1943e42e6adf6', // wbera-bbot
    '0xc227c8639a41db8393dd1b4eac41464a62d64fb4': '0x3c8e4d4324f7ab2e3238c23a2838a762ecb7051d', // ohm-bera
    '0x2CaFe99dB26Cf86Ae8587F5934830d25aD5C3Cb3': '0xb4a1519956cee0798eaac3de08f1531f58a0c950', // bitcoin-wbera
    '0x28a54eaeec63fbb1175d13466a9ada5f3175d577': '0x274441c8c34b7785fada01ec0d7fe9ba2c72aea0', // usdbr-honey
    '0x218c12fe0c2f8a507929d4f5c30a83e38fbca285': '0x517dbcd3d89ef5a59b02a4142274e3dd5aed5626', // nect-wbera
    '0xd9a747880393f7c33cEf1aea36909b36d421F7E5': '0xc080b212caaa1ebbccde1434d6efe6359eda2084', // bread-ohm
    '0x54c603173CA92A42B81f8838d705fd3E0f98D5D4': '0x930b9467774561b8c7692336B7Cf2d465378d12f', // bread-lbgt
    '0x337eF1eB6c8BBeD571170Fc2b468608ab9e2Aac8': '0xbebce77b3553d6da3b1f8281cc8115266c92cbea', // lbgt-wbera
    '0x5e4fe86c4f6fb2203fbfb77fd6ec3cb300b639aa': '0x83a0Fd7F2C93179443984Bac4B8b8F04aAaa053B', // dolo-wbera
    '0x9f6cf7aCb2F16f7d906EeeCB0a6020a5Cf91A41d': '0x33e38ccd66a3c07f0e22bb3751a6a0fc0335f31c', // lair-wbera
    '0xE98763d61Ab493A55963583bcDD854580E084B5b': '0x6542598386628673fFADe347594ddD0B1Cb3676c', // lbgt-pbera
  },
}

export const ISLANDS_TO_FARM: { [chainId: string]: Record<string, string | undefined> } = Object.fromEntries(
  Object.entries(ISLANDS_TO_FARM_DATA).map(([chainId, pairs]) => [
    chainId,
    Object.fromEntries(Object.entries(pairs).map(([key, value]) => [key.toLowerCase(), value?.toLowerCase()])),
  ])
)

export const ISLAND_BONUS_INFO: { [islandId: string]: { multipliers: string[]; extraInfo?: string; icon?: string } } = {
  // BERA/iBGT pool
  // '0xec8ba456b4e009408d0776cde8b91f8717d13fa1': {
  //   multipliers: ['1.5x Rings Multiplier', '8x Sonic Multiplier', '3x Veda Multiplier'],
  //   extraInfo: 'earns points',
  //   icon: 'star',
  // },
  // // RAMEN-BERA
  // '0x93a913351cae2d8c82c4b85f699726947eb76d32': {
  //   multipliers: ['3x BGT Multiplier'],
  //   extraInfo: 'Part of Reward Vaults program',
  //   icon: 'star',
  // },
}

export const POOL_TO_INFRARED_VAULT_DATA: { [chainId: string]: Record<string, string | undefined> } = {
  [SupportedChainId.BERA]: {
    '0xad445256ff81171043a5e7cd8831e4371b000176': 'kodiak-ibera-osbgt', // iBERA-OSBGT
    '0xe3eeb9e48934634d8b5b39a0d15dd89ee0f969c4': 'kodiak-wbera-ibera', // iBERA-WBERA
    '0x564f011d557aad1ca09bfc956eb8a17c35d490e0': 'kodiak-wbera-ibgt', // iBGT-WBERA
    '0x24afceb372b755f4953e738d6b38e9e4646d9f57': 'kodiak-ibera-ibgt', // iBGT-iBERA
  },
}

export const POOL_TO_INFRARED_VAULT: { [chainId: string]: Record<string, string | undefined> } = Object.fromEntries(
  Object.entries(POOL_TO_INFRARED_VAULT_DATA).map(([chainId, pairs]) => [
    chainId,
    Object.fromEntries(Object.entries(pairs).map(([key, value]) => [key.toLowerCase(), value?.toLowerCase()])),
  ])
)

export const QUOTE_TOKEN_PRIORITY_LIST: { [key: string]: number } = {
  //majors
  BUSD: 100,
  USDG: 100,
  USDT0: 99,
  'USDC.e': 99,

  // usd stablecoins
  USDe: 98,
  sUSDe: 97,
  rUSD: 96,
  USDa: 96,
  sUSDa: 95,
  NECT: 96,
  MIM: 95,
  OHM: 95,
  USDBR: 95,

  WBTC: 94,
  WETH: 93,
  WBERA: 90,
  BERA: 90,
  iBERA: 89,
  sWBERA: 89,
  BREAD: 88,
  'eWBERA-4': 88,
  yBERA: 88,

  iBGT: 87,
  LBGT: 86,
  yBGT: 86,
  osBGT: 85,

  // eth lsts
  beraETH: 86,
  rsETH: 85,
  rswETH: 85,
  STONE: 85,

  // KDK
  KDK: 80,

  // btc wrappers
  FBTC: 30,
  SBTC: 30,
  stBTC: 30,
  // btc lsts
  'pumpBTC.bera': 25,
  uniBTC: 25,
  waBTC: 25,
  SolvBTC: 25,
  'SolvBTC.BBN': 24,
  // cian
  ylstETH: 15,
  ylBTCLST: 15,
  ylPumpBTC: 15,
  ylrsETH: 15,
  // goldilocks
  'rsETH-OT': 10,
  'SolvBTC.BBN-OT': 10,
  'uniBTC-OT': 10,
}

export const FARM_BLACKLIST: { [chainId: string]: string[] } = {
  [SupportedChainId.BERA]: [
    '0xbac50937f729bc07bab4fc704ab1b7b9b71f59dc', //test farm
    '0x19231d2625b1e8ae77176e9dd90ee29960504f7b', //old jani farm
    '0xc9eD600ba54A8910F29fb9533885aAd7ee623565',
    '0xd7F7f197F04cD3Da06c15C4b6b4640479794e986',
    '0x19231D2625b1E8Ae77176e9dD90Ee29960504f7B',
    '0x40C4d0a87157c3C1Df26267AC02505D930BAeEEb', // WBERA-HONEY KODIAK FARM
    '0xF41eCc551E3c7449E74a7a7464BB2674fA76954c', // WBERA-WETH
    '0x1C8e199c6c42D5ccE652Cf02002694D937118177', // WBERA-YEET
    '0x0d74359866a86d0f192f5cd53d103d299043165b', // wbtc-wbera
    '0x138b9fcc820bb56fa9accc99fd2041f7d1363ec1', // bm-wbera
    '0x6F22221dC5845A25597BC96629D92F2b4979D943', // wbera-ramen
    // '0xc6d2205aabbdc0d7ce40a05eb6a1943e42e6adf6', // wbera-bbot
    '0x3c8e4d4324f7ab2e3238c23a2838a762ecb7051d', // ohm-bera
    '0xb4a1519956cee0798eaac3de08f1531f58a0c950', // bitcoin-wbera
    '0xc080b212caaa1ebbccde1434d6efe6359eda2084', // bread-ohm
    '0x274441c8c34b7785fada01ec0d7fe9ba2c72aea0', // usdbr-honey
    '0x517dbcd3d89ef5a59b02a4142274e3dd5aed5626', // nect-wbera
  ].map((x) => x.toLowerCase()),
}

export const INFRARED_CHARM_VAULTS: { [chainId: number]: string[] } = {
  [SupportedChainId.BERA]: [
    '0xe15db2653d0bb242e09066e97c231c1404fca45d', // Charm iBERA-iBGT
    '0xae5d9f1069e50ce400b7d9ee44b0957eddc4d23a', // Charm WBERA-IR
    '0x92e9fd03208b9291791c46d1bd8253f678c24ec7', // Charm USDT0-IR
  ].map((x) => x.toLowerCase()),
}
